import { Controller } from "stimulus";
import "selectize";

export default class extends Controller {
  static targets = ["select"];

  connect() {
    if (!this.hasSelectTarget) {
      return;
    }

    const $select = $(this.selectTarget);
    $select.selectize({
      create: false,
      maxItems: 1,
      selectOnTab: true,
      placeholder: "Type to search candidates...",
      onChange: () => {
        // Ensure listeners bound to native change events still run.
        this.selectTarget.dispatchEvent(new Event("change", { bubbles: true }));
      },
    });

    this.selectize = $select[0].selectize;
  }

  disconnect() {
    if (this.selectize) {
      this.selectize.destroy();
      this.selectize = null;
    }
  }
}
